import { createSlice } from '@reduxjs/toolkit';

import { fetchGet } from '../../helpers/fetching';
import { getNewSelected, unwindDevices } from '../../helpers/misc';
import { setSnackbar } from './gui';
import { createOperatorList } from './../../helpers/misc';

const initialState = {
  institution_list: [],
  institution_rules: {},
  device_list: [],
  operator_list: [],
};

export const operatorsDevicesSlice = createSlice({
  name: 'devices',
  initialState,
  reducers: {
    setOperatorList: (state, action) => {
      state.operator_list = action.payload;
    },
    setDeviceList: (state, action) => {
      state.device_list = action.payload;
    },
    setInstitutionList: (state, action) => {
      state.institution_list = action.payload;
    },
    setInstitutionRules: (state, action) => {
      state.institution_rules = action.payload;
    },
  },
});

export const { setOperatorList, setDeviceList, setInstitutionList, setInstitutionRules } =
  operatorsDevicesSlice.actions;

export default operatorsDevicesSlice.reducer;

// Asynchronous
export const fetchOperators = () => {
  return async (dispatch, getState) => {
    let operatorResponse = fetchGet('operators');
    let userResponse = fetchGet('users?role=technician');
    let optedOutResponse = fetchGet('operators_opted_out');

    operatorResponse = await operatorResponse;
    if (!operatorResponse.success) {
      dispatch(
        setSnackbar({
          msg: operatorResponse.msg,
          severity: 'error',
        }),
      );
      return;
    }

    userResponse = await userResponse;
    if (!userResponse.success) {
      dispatch(
        setSnackbar({
          msg: userResponse.msg,
          severity: 'error',
        }),
      );
      return;
    }

    const optedOutAliases = new Set(
      (userResponse.data || [])
        .filter((user) => !!user.statistics_opt_out)
        .flatMap((user) =>
          (user.aliases || '')
            .split(';')
            .map((alias) => alias.trim().toLowerCase())
            .filter(Boolean),
        ),
    );

    const filteredOperators = (operatorResponse.data || []).filter(
      (operator) => !optedOutAliases.has((operator.name || '').toLowerCase()),
    );
    const filteredUsers = (userResponse.data || []).filter((user) => !user.statistics_opt_out);

    const new_operator_list = createOperatorList(filteredOperators, filteredUsers);

    dispatch(setOperatorList(new_operator_list));
  };
};

export const fetchDevices = () => {
  return async (dispatch, getState) => {
    const response = await fetchGet('devices');

    if (!response.success) {
      dispatch(
        setSnackbar({
          msg: `api_messages.${response.msg}`,
          severity: 'error',
        }),
      );
      return;
    }

    dispatch(setDeviceList(response.data));
  };
};

export const fetchInstitutions = () => {
  return async (dispatch, getState) => {
    const response = await fetchGet('institutions');
    if (!response.success) {
      dispatch(
        setSnackbar({
          msg: `api_messages.${response.msg}`,
          severity: 'error',
        }),
      );
      return;
    }

    dispatch(setInstitutionList(response.data.institutions));
    dispatch(setInstitutionRules(response.data.rules));
  };
};
